import { render, staticRenderFns } from "./BenefitCategory.vue?vue&type=template&id=a05869d4&"
import script from "./BenefitCategory.vue?vue&type=script&lang=js&"
export * from "./BenefitCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports